module.exports = __webpack_public_path__ + "img/sangbuk-logo.50d2fc8a.svg";